module.exports = __webpack_public_path__ + "static/media/standart_doorstep.2ecdec8f.png";